/* global FB */

import {connect} from 'react-redux';

import * as AuthActions from '../store/actions/authActions';
import Signup from '../components/Signup';

const mapStateToProps = (state) => ({
    ...state.auth

});


const mapDispatchToProps = (dispatch) => ({
    onRegister: (email, password, name, lname, role, image, google, fb, courseRegistration, browser) => {
        dispatch(AuthActions.RegisterUser(email, password, name, lname, role, image, google, fb, courseRegistration, browser));
    },
    loginUserFailure: (error) => {
        dispatch(AuthActions.loginUserFailure(error));
    },
    authClear: () => {
        dispatch(AuthActions.clearErrors());
    },
    getAllCourses: () => {
        dispatch(AuthActions.getAllCourses());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Signup);



// WEBPACK FOOTER //
// ./src/containers/SignupContainer.js